import * as Yup from 'yup';
import {
  isDateTimeInFuture,
  isValidDateTimeInput
} from '../../../../utils/date';

const DEFAULT_STRING_FIELD = Yup.string().required('Campo é obrigatório');
const DEFAULT_BOOLEAN_FIELD = Yup.boolean()
  .required('Campo é obrigatório')
  .nullable();
const DEFAULT_ARRAY_FIELD = Yup.array().required('Campo é obrigatório');
const DATE_FIELD = Yup.string()
  .required('Campo é obrigatório')
  .test(
    'not-in-future',
    'A data da ocorrência não pode ser no futuro',
    value => {
      if (!value) return true;
      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) return false;
      return parsedDate.getTime() <= Date.now();
    }
  );
const OPTIONAL_DATE_FIELD = (invalidMessage: string, futureMessage: string) =>
  Yup.string()
    .nullable()
    .test('valid-date-time', invalidMessage, value => {
      if (!value) return true;
      return isValidDateTimeInput(value);
    })
    .test('not-in-future', futureMessage, value => {
      if (!value) return true;
      return !isDateTimeInFuture(value);
    });
const POLICE_UNIT_FIELD = (actionPoliceReasonId?: string) =>
  Yup.string()
    .nullable()
    .when('main_reason', {
      is: (value: unknown) =>
        !!actionPoliceReasonId && value === actionPoliceReasonId,
      then: Yup.string().nullable().required('Campo é obrigatório'),
      otherwise: Yup.string().nullable()
    });
const DEFAULT_AGENT_FIELD = Yup.string()
  .nullable()
  .when(['type_person'], {
    is: (type: any) => type === 'Agent',
    then: Yup.string()
      .nullable()
      .required(
        'Campo é obrigatório. Em caso de informação faltante, preencher com "Não identificado".'
      )
  });
const DEFAULT_POLITICAL_FIELD = Yup.string()
  .nullable()
  .when(['qualifications'], {
    is: (qualifications: any) => {
      return qualifications?.find(
        (qualification: { label: string }) => qualification.label === 'Político'
      );
    },
    then: Yup.string()
      .nullable()
      .required(
        'Campo é obrigatório. Em caso de informação faltante, preencher com "Não identificado".'
      )
  });

export const schemaOccurrence = (
  pressSourceId: any,
  actionPoliceReasonId?: string
) =>
  Yup.object().shape({
    address: DEFAULT_STRING_FIELD,
    state: DEFAULT_STRING_FIELD,
    city: DEFAULT_STRING_FIELD,
    date: DATE_FIELD,
    source: DEFAULT_STRING_FIELD,
    police_action: DEFAULT_BOOLEAN_FIELD,
    agent_presence: DEFAULT_BOOLEAN_FIELD,
    main_reason: DEFAULT_STRING_FIELD,
    massacre: DEFAULT_BOOLEAN_FIELD,
    police_unit: POLICE_UNIT_FIELD(actionPoliceReasonId),
    description: DEFAULT_STRING_FIELD,
    related_news: Yup.string()
      .nullable()
      .when(['source'], {
        is: (source: any) => source === pressSourceId,
        then: DEFAULT_STRING_FIELD
      }),
    occurrenceTransportsTransport: Yup.array().of(
      Yup.object().shape({
        transportId: DEFAULT_STRING_FIELD,
        date_interruption: OPTIONAL_DATE_FIELD(
          'Data da interrupção inválida',
          'A data da interrupção não pode ser no futuro'
        ),
        release_date: OPTIONAL_DATE_FIELD(
          'Data da liberação inválida',
          'A data da liberação não pode ser no futuro'
        )
      })
    ),
    victims: Yup.array().of(
      Yup.object().shape({
        situation: DEFAULT_STRING_FIELD,
        type_person: DEFAULT_STRING_FIELD,
        qualifications: DEFAULT_ARRAY_FIELD,
        circumstances: DEFAULT_ARRAY_FIELD,
        age_group: DEFAULT_STRING_FIELD,
        genre: DEFAULT_STRING_FIELD,
        race: DEFAULT_STRING_FIELD,
        place: DEFAULT_STRING_FIELD,
        death_date: Yup.string()
          .nullable()
          .when(['situation'], {
            is: (situation: any) => situation === 'Dead',
            then: OPTIONAL_DATE_FIELD(
              'Data da morte inválida',
              'A data da morte não pode ser no futuro'
            ).required('Campo é obrigatório'),
            otherwise: OPTIONAL_DATE_FIELD(
              'Data da morte inválida',
              'A data da morte não pode ser no futuro'
            )
          }),
        coorporation: DEFAULT_AGENT_FIELD,
        agent_position: DEFAULT_AGENT_FIELD,
        agent_status: DEFAULT_AGENT_FIELD,
        partie: DEFAULT_POLITICAL_FIELD,
        political_status: DEFAULT_POLITICAL_FIELD,
        political_position: DEFAULT_POLITICAL_FIELD
      })
    ),
    victims_animal: Yup.array().of(
      Yup.object().shape({
        situation: DEFAULT_STRING_FIELD,
        animal_type: DEFAULT_STRING_FIELD,
        circumstances: DEFAULT_ARRAY_FIELD,
        death_date: OPTIONAL_DATE_FIELD(
          'Data da morte inválida',
          'A data da morte não pode ser no futuro'
        )
      })
    )
  });
